import auth from "../../middlewares/auth";
export const settingsFolderUnitRoute = [
  {
    path: '/settings/folder_units',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/folder_unit/FolderUnitList'),
    name: 'settings_folder_unit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/folder_units/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/folder_unit/FolderUnitForm'),
    name: 'settings_folder_unit_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/folder_units/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/folder_unit/FolderUnitForm'),
    name: 'settings_folder_unit_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];